import { onMounted, onUnmounted } from 'vue'

export function useEventListener(target = document, eventType, listener, options) {
  onMounted(() => {
    target.addEventListener(eventType, listener, options)
  })

  onUnmounted(() => {
    target.removeEventListener(eventType, listener, options)
  })
}
